import "@/App.css";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "@/lib/query-client";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import AppLayout from "@/components/layout/AppLayout";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import PreKSessions from "@/pages/PreKSessions";
import K2Sessions from "@/pages/K2Sessions";
import Sessions35 from "@/pages/Sessions35";
import Sessions68 from "@/pages/Sessions68";
import Sessions912 from "@/pages/Sessions912";
import OtherStaff from "@/pages/OtherStaff";
import Resources from "@/pages/Resources";
import Admin from "@/pages/Admin";
import PageNotFound from "@/pages/PageNotFound";

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route element={<AppLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/preksessions" element={<PreKSessions />} />
            <Route path="/k2sessions" element={<K2Sessions />} />
            <Route path="/sessions35" element={<Sessions35 />} />
            <Route path="/sessions68" element={<Sessions68 />} />
            <Route path="/sessions912" element={<Sessions912 />} />
            <Route path="/otherstaff" element={<OtherStaff />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/admin" element={<Admin />} />
          </Route>
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </Router>
    </QueryClientProvider>
  );
}

export default App;
